import { IonPage, IonHeader, IonToolbar, IonButtons, IonBackButton, IonContent, IonRefresher, IonRefresherContent, IonTitle, IonButton, IonIcon, useIonViewWillEnter, IonText, IonPopover, IonList, IonItem } from "@ionic/react";
import { keyOutline, logOutSharp, personCircle } from "ionicons/icons";

import { useRef, useState } from "react";
import { useHistory } from "react-router"
import { UserProfile } from "../components/UserProfile";
import { createStore } from "../data/persistent/IonicStore";
import "./Profile.css";

const Profile: React.FC = ()=>{
    const [userInfo, setUserInfo] = useState<any>(null);
    const popover = useRef<HTMLIonPopoverElement>(null);
    const [popoverOpen, setPopoverOpen] = useState(false);
    const openPopover = (e: any) => {
      popover.current!.event = e;
      setPopoverOpen(true);
    };
    const history = useHistory();
    useIonViewWillEnter(()=>{
      const loadLocal = async()=>{
        let lcStorage = await createStore();
        let lcvalue = await lcStorage.get("login_info");
        if(lcvalue !== null){
          setUserInfo(JSON.parse(lcvalue));
        }
      }
      loadLocal();
    },[]);
    const refresh = (e: CustomEvent) => {
      setTimeout(() => {
        e.detail.complete();
      }, 3000);
    };
    const logoutHandler = async()=>{
        let lcstorage = await createStore();
        lcstorage.remove("login_info");
        console.log('xoa profile');
        setPopoverOpen(false);
        history.push("/");
    }
    if(userInfo !== null){
      return <>
      
      <IonPage id="view-profile-page">
        <IonHeader translucent>
          <IonToolbar>
            <IonButtons slot="start">
              <IonBackButton text={"Profile:"+ userInfo !== null?userInfo.hoten:""} defaultHref={"/profile"}></IonBackButton>
            </IonButtons>
            <IonButtons slot="end">
              <IonButton onClick={openPopover}>
                 <IonIcon color={"success"} icon={personCircle}/></IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonPopover ref={popover} isOpen={popoverOpen} onDidDismiss={() => setPopoverOpen(false)}>
          <IonList>
            <IonItem>THAO TÁC</IonItem>
            
            <IonItem onClick = {()=>{
              setPopoverOpen(false);
              history.push('/passwordchange');
            }}>
              <IonIcon icon={keyOutline} />Đổi mật khẩu
            </IonItem>
            
            <IonItem onClick={logoutHandler}>
              <IonIcon icon = {logOutSharp} />Đăng xuất
            </IonItem>
          </IonList>
        </IonPopover>
        <IonContent fullscreen>
            <IonRefresher slot="fixed" onIonRefresh={refresh}>
              <IonRefresherContent></IonRefresherContent>
            </IonRefresher>

            <IonHeader collapse="condense">
              <IonToolbar>
                <IonTitle size="large">
                  Profile: {userInfo !== null?userInfo.hoten:""}
                </IonTitle>
              </IonToolbar>
            </IonHeader>

            <UserProfile item={userInfo} />
        </IonContent>
      </IonPage>
      </>
    }else{
      return <IonPage>
        <IonContent fullscreen>
            <IonText className="center_alight">Bạn cần đăng nhập lại</IonText>
            <IonButton expand="block" onClick={()=>{history.push('/login')}}>Đến trang đăng nhập</IonButton>
        </IonContent>
      </IonPage>
    }
}
export default Profile;